import { PUBLIC_PAGE_TRANSLATIONS } from './publicPages';
import { ADMIN_MODULE_TRANSLATIONS } from './adminModules';

export const EXTRA_TRANSLATIONS = {
  es: {
    ...PUBLIC_PAGE_TRANSLATIONS.es,
    ...ADMIN_MODULE_TRANSLATIONS.es,
  },
  en: {
    ...PUBLIC_PAGE_TRANSLATIONS.en,
    ...ADMIN_MODULE_TRANSLATIONS.en,
  },
  fr: {
    ...PUBLIC_PAGE_TRANSLATIONS.fr,
    ...ADMIN_MODULE_TRANSLATIONS.fr,
  },
  pt: {
    ...PUBLIC_PAGE_TRANSLATIONS.pt,
    ...ADMIN_MODULE_TRANSLATIONS.pt,
  },
  de: {
    ...PUBLIC_PAGE_TRANSLATIONS.de,
    ...ADMIN_MODULE_TRANSLATIONS.de,
  },
};
